module.exports = __webpack_public_path__ + "img/swiper_3.0_3_1.3f5d821f.webp";